module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-75Bold.6f999f27.woff";